module.exports = __webpack_public_path__ + "html/pricing_27f8f185d68d649e317d92e5d40f1317.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio/pricing.html
// module id = v+R/
// module chunks = 51